import { moduleProviderFactory } from 'core/providers';
import { RateCalculator } from 'modules/rate-calculator/pages';

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: 'master.app.main.rate-calculator',
				pattern: '/rate-calculator',
				isPrivate: true,
				children: [
					{
						name: 'master.app.main.rate-calculator',
						pattern: '',
						component: RateCalculator,
					},
				],
			},
		],
	});
})();



// WEBPACK FOOTER //
// ./src/modules/rate-calculator/config.js